import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import cloneDeep from 'lodash.clonedeep';
import { StreamID } from '@ceramicnetwork/streamid';
import { CommitID } from '@ceramicnetwork/streamid';
import { Observable } from 'rxjs';
import { SyncOptions } from './streamopts.js';
export var SignatureStatus;
(function (SignatureStatus) {
  SignatureStatus[SignatureStatus["GENESIS"] = 0] = "GENESIS";
  SignatureStatus[SignatureStatus["PARTIAL"] = 1] = "PARTIAL";
  SignatureStatus[SignatureStatus["SIGNED"] = 2] = "SIGNED";
})(SignatureStatus || (SignatureStatus = {}));
export var AnchorStatus;
(function (AnchorStatus) {
  AnchorStatus[AnchorStatus["NOT_REQUESTED"] = 0] = "NOT_REQUESTED";
  AnchorStatus[AnchorStatus["PENDING"] = 1] = "PENDING";
  AnchorStatus[AnchorStatus["PROCESSING"] = 2] = "PROCESSING";
  AnchorStatus[AnchorStatus["ANCHORED"] = 3] = "ANCHORED";
  AnchorStatus[AnchorStatus["FAILED"] = 4] = "FAILED";
})(AnchorStatus || (AnchorStatus = {}));
export var CommitType;
(function (CommitType) {
  CommitType[CommitType["GENESIS"] = 0] = "GENESIS";
  CommitType[CommitType["SIGNED"] = 1] = "SIGNED";
  CommitType[CommitType["ANCHOR"] = 2] = "ANCHOR";
})(CommitType || (CommitType = {}));
export var Stream = /*#__PURE__*/function (_Observable) {
  _inherits(Stream, _Observable);
  var _super = _createSuper(Stream);
  function Stream(state$, _context) {
    var _this;
    _classCallCheck(this, Stream);
    _this = _super.call(this, function (subscriber) {
      state$.subscribe(subscriber);
    });
    _this.state$ = state$;
    _this._context = _context;
    return _this;
  }
  _createClass(Stream, [{
    key: "id",
    get: function get() {
      return new StreamID(this.state$.value.type, this.state$.value.log[0].cid);
    }
  }, {
    key: "api",
    get: function get() {
      return this._context.api;
    }
  }, {
    key: "metadata",
    get: function get() {
      var _next$metadata;
      var _this$state$$value = this.state$.value,
        next = _this$state$$value.next,
        metadata = _this$state$$value.metadata;
      return cloneDeep((_next$metadata = next === null || next === void 0 ? void 0 : next.metadata) !== null && _next$metadata !== void 0 ? _next$metadata : metadata);
    }
  }, {
    key: "content",
    get: function get() {
      var _next$content;
      var _this$state$$value2 = this.state$.value,
        next = _this$state$$value2.next,
        content = _this$state$$value2.content;
      return cloneDeep((_next$content = next === null || next === void 0 ? void 0 : next.content) !== null && _next$content !== void 0 ? _next$content : content);
    }
  }, {
    key: "controllers",
    get: function get() {
      return this.metadata.controllers;
    }
  }, {
    key: "tip",
    get: function get() {
      return this.state$.value.log[this.state$.value.log.length - 1].cid;
    }
  }, {
    key: "commitId",
    get: function get() {
      return CommitID.make(this.id, this.tip);
    }
  }, {
    key: "allCommitIds",
    get: function get() {
      var _this2 = this;
      return this.state$.value.log.map(function (_ref) {
        var cid = _ref.cid;
        return CommitID.make(_this2.id, cid);
      });
    }
  }, {
    key: "anchorCommitIds",
    get: function get() {
      var _this3 = this;
      return this.state$.value.log.filter(function (_ref2) {
        var type = _ref2.type;
        return type === CommitType.ANCHOR;
      }).map(function (_ref3) {
        var cid = _ref3.cid;
        return CommitID.make(_this3.id, cid);
      });
    }
  }, {
    key: "state",
    get: function get() {
      return cloneDeep(this.state$.value);
    }
  }, {
    key: "sync",
    value: function () {
      var _sync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var opts,
          stream,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              opts = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              opts = _objectSpread({
                sync: SyncOptions.PREFER_CACHE
              }, opts);
              _context2.next = 4;
              return this.api.loadStream(this.id, opts);
            case 4:
              stream = _context2.sent;
              this.state$.next(stream.state);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee, this);
      }));
      function sync() {
        return _sync.apply(this, arguments);
      }
      return sync;
    }()
  }, {
    key: "requestAnchor",
    value: function () {
      var _requestAnchor = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.api.requestAnchor(this.id));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee2, this);
      }));
      function requestAnchor() {
        return _requestAnchor.apply(this, arguments);
      }
      return requestAnchor;
    }()
  }]);
  return Stream;
}(Observable);
export function StreamStatic() {
  return function (constructor) {
    constructor;
  };
}